export { default } from './TasksService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksService/index.js